module.exports = __webpack_public_path__ + "syndication/Components/PersistentActions/pocket.8606124d9c736a683423199e4b4cfd91.svg";